import { Control, Controller } from 'react-hook-form'

import { TextField } from '@mui/material'
import { Video } from 'features/videos/service'

type Props = {
  control: Control<Video>
}

export const SeoDescriptionController = ({ control }: Props) => {
  return (
    <Controller
      control={control}
      defaultValue={''}
      name={'seoDescription'}
      render={({ field, fieldState }) => {
        return (
          <TextField
            error={!!fieldState.error}
            fullWidth
            multiline
            label={'SEO описание'}
            style={{ marginTop: '10px' }}
            {...field}
          />
        )
      }}
    />
  )
}
